import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { DrivingSchool } from './views/DrivingSchool';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<DrivingSchool />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.DrivingSchool)
	.build();

export default Layout;
